import {useContext} from 'react';
import PermissionContext from "./permission-context";
import {Permission} from "./types";

const usePermission = (permission: Permission) => {
    const {isAllowedTo} = useContext(PermissionContext);
    return isAllowedTo(permission);
}

export default usePermission;